"use client";

import { useState } from "react";

import { Button } from "@/components/ui/button";

import { SignInModal } from "./SignInModal";

interface SignInButtonProps {
  children?: React.ReactNode;
  variant?: "default" | "outline" | "ghost" | "link";
  size?: "default" | "sm" | "lg";
  destination?: string;
}

export function SignInButton({
  children = "Sign in",
  variant = "default",
  size = "default",
  destination,
}: SignInButtonProps) {
  const [open, setOpen] = useState(false);

  return (
    <div>
      <Button variant={variant} size={size} onClick={() => setOpen(true)}>
        {children}
      </Button>
      <SignInModal
        open={open}
        onOpenChange={setOpen}
        destination={destination}
      />
    </div>
  );
}
